enum DocumentVersionStatus {
    InProgress = 0,
    AwaitingApproval = 1,
    Approved = 2,
    Rejected = 3
}

export default DocumentVersionStatus;